import React from 'react';
import {IndexRoute, Route} from 'react-router';
import {
    TakePasswordOne,
    TakePasswordTwo,
    TakePasswordThree
} from 'containers';

export default (store) => {
  return (
    <Route>
      <Route path="aa/takepassword/step1" component={TakePasswordOne}/>
      <Route path="aa/takepassword/step2" component={TakePasswordTwo}/>
      <Route path="aa/takepassword/step3" component={TakePasswordThree}/>
      <Route path="*" component={TakePasswordOne}/>
    </Route>
  );
};
